import { NavLink, Link } from "react-router-dom";
import { CATEGORY_TABS } from "../../constant/menulist";
import { LINE_URL } from "../../constant/contact";
import { useLoginGate } from "../../context/login-gate";
import "./nav-style.scss";

//首頁頂部導覽
//
//  純手機版：只有一種形態 —— 精簡 header（logo + 搜尋 + 客服 + 漢堡）
//  加上底下一列可橫向捲動的分類。桌機看到的是同一份。
//
//  漢堡不是展開抽屜，而是直接進「帳號中心」——
//  抽屜與帳號中心會是兩份重複的選單，維護時很容易只改一邊。
//  未登入時不導頁，在原地跳登入彈窗（見 context/login-gate）。

//分類列要不要顯示。
//
//  暫時收起來（Kevin 2026-10-20）：產品只有五支，而且其中幾支的
//  categories 是空陣列 —— 分頁點進去是一片空的清單，比沒有這排更糟。
//
//  版型與 CATEGORY_TABS 都留著，改成 true 就回來。產品數量長到
//  「一頁列不完」的時候再打開，那才是分類開始有用的時機。
//
//  ⚠️ 連帶影響：/category/:key 這條 route 還活著，但沒有入口了
//  （那排標籤是唯一的去處）。要保留分類頁就得另外給入口。
const SHOW_CATEGORY_TABS = false;

const NavList = () => {
  const { requireLogin } = useLoginGate();

  return (
    <header className="nav">
      <div className="nav__bar">
        <Link to="/" className="nav__logo">
          <span className="nav__logo-mark">閻異閣</span>
        </Link>

        <div className="nav__actions">
          <Link to="/search" className="nav__icon-btn" aria-label="搜尋">
            <IconSearch />
          </Link>
          {/* 客服走 LINE 官方帳號，不是站內的 /support ——
              那條 route 從來沒做出來，點下去是白頁（跟頁尾的 /policy 同一種坑）。
              而且客服本來就在 LINE 上，再做一頁站內客服等於兩個入口要各自有人顧。
              站外連結要 noreferrer：少了它，對方的頁面可以透過
              window.opener 回頭操作我們這一頁。 */}
          <a
            href={LINE_URL}
            target="_blank"
            rel="noreferrer"
            className="nav__icon-btn"
            aria-label="官方 LINE 客服"
          >
            <IconSupport />
          </a>
          <button
            type="button"
            className="nav__icon-btn"
            aria-label="帳號中心"
            onClick={() =>
              requireLogin(
                "/account",
                "登入後即可查看你的報告、優惠券與個人資料。",
              )
            }
          >
            <IconMenu />
          </button>
        </div>
      </div>

      {/* 分類列：可橫向捲動，項目多了也不會擠壓。
          產品還太少，暫時收起來 —— 見上面的 SHOW_CATEGORY_TABS。 */}
      {SHOW_CATEGORY_TABS && (
        <div className="nav__tabs-row">
          <nav className="nav__tabs no-scrollbar">
            {CATEGORY_TABS.map((tab) => (
              <NavLink
                key={tab.key}
                to={tab.path}
                end={tab.path === "/"}
                className={({ isActive }) =>
                  isActive ? "nav__tab is-active" : "nav__tab"
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}

    </header>
  );
};

//—— 圖示 ——
//  inline SVG 而非 icon 套件：全站只用到幾個圖示，為此多載一包 library 不划算，
//  而且 inline 才能直接吃 currentColor 跟著主題變色。
const IconMenu = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
    <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" fill="none" />
  </svg>
);

const IconSearch = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
    <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8" fill="none" />
    <path d="M16.5 16.5L21 21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const IconSupport = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
    <path d="M4 13a8 8 0 0116 0" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round" />
    <rect x="2.5" y="13" width="4.5" height="7" rx="2" stroke="currentColor" strokeWidth="1.8" fill="none" />
    <rect x="17" y="13" width="4.5" height="7" rx="2" stroke="currentColor" strokeWidth="1.8" fill="none" />
  </svg>
);

export default NavList;
